import { useMemo } from "react";
import SaveDayTemplate from "../../components/modals/SaveDayAsTemplate";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useSaveDayAsTemplateModal = () => {
    const { visible, open, close, selected } = useVisible();

    const modal = useMemo(() => {
        return (
            <SaveDayTemplate 
                visible={visible}
                close={close}
                date={selected}
            />
        );
    }, [visible, selected, close]);

    return { open, modal };
}
